import React from 'react';
import { format, parseISO } from 'date-fns';
import rightArrow from '../images/clickablerightarrow.svg';
import { sendFirebaseEvent } from '../../../helper/mobile';

const DietPlanCard = ({dietPlan, isClickable, specialLabel, onclickPlanCard}) => {
  const pricePercentSaved = Math.floor(100 - ((dietPlan.salePrice / dietPlan.price) * 100));
  const getPaymentStatus = (status, dt) => {
    if(status === 'payment_initiated' || status === 'payment_successful') {
      if(dt)
        return 'Currently active';
      else
        return dietPlan.dietPlanType === 'one_month_smart_diet_plan' ? 'Not yet started' : 'Paid. Not yet started';
    }
  }
  return (
    <div className='diet-plan-card mb-4' onClick={() => sendFirebaseEvent('diet_plan_type_click', 'click_event', dietPlan.dietPlanType)}>
      <p className='diet-plan-card-label'>{dietPlan.label}</p>
      <h4 className='mb-0'>
        <span className='diet-plan-card-salePrice'>{dietPlan.dietPlanType === 'one_month_smart_diet_plan' ? '' : '₹'}{dietPlan.salePrice}</span>
        <strike className='diet-plan-card-price'>₹{dietPlan.price}</strike>
        {
          isClickable ? <img src={rightArrow} className='diet-plan-card-arrow float-end' alt='right arrow' /> :
          <>
            {dietPlan?.paymentStatus ? <span className='diet-plan-card-payment float-end'>{getPaymentStatus(dietPlan.paymentStatus, dietPlan.planStartDate)}</span> :
              <span className='diet-plan-card-price-percent-save float-end'>{dietPlan.dietPlanType === 'one_month_smart_diet_plan' ? 'limited time only' : `${pricePercentSaved}% Discount`}</span>
            }
          </>
        }
      </h4>
      {specialLabel && dietPlan.specialLabel && <label className='diet-plan-card-speciallabel'>{dietPlan.specialLabel}</label> }
      <div className='mt-1 diet-plan-card-date'>
        { dietPlan.planStartDate && <span>Started: {format(parseISO(dietPlan.planStartDate), "dd MMM yyyy")}</span> }
        { dietPlan.planEndDate && <span className='float-end'>Ends: {format(parseISO(dietPlan.planEndDate), "dd MMM yyyy")}</span> }
      </div>
    </div>
  );
}

export default DietPlanCard;
